import type { SlideProps } from "@/engine/app/offsite-config";

// Wortgleich mit den sechs Feldern des Anforderungs-Formulars
// (TeamWorkspace DEFAULT_FIELDS) — die Folie erklärt, was die Handys
// gleich anzeigen.
const FELDER = [
  {
    label: "Was soll gebaut werden?",
    tipp: "2–3 Sätze — wie ein Auftrag an eine Fremdfirma.",
  },
  {
    label: "Für wen ist das?",
    tipp: "Rolle nennen: Sachbearbeitung, Monteur, Kunde …",
  },
  {
    label: "Welches Problem löst es?",
    tipp: "Der heutige Schmerz — nicht schon die Lösung.",
  },
  {
    label: "Was muss es können?",
    tipp: "Aufzählung, jede Zeile einzeln prüfbar.",
  },
  {
    label: "Was darf es NICHT?",
    tipp: "Leitplanken: keine echten Kundendaten, nichts automatisch versenden …",
  },
  {
    label: "Beispiel-Szenario",
    tipp: "Ein konkreter Durchlauf, gern mit Zahlen.",
  },
];

export function Slide11cSoArbeitetIhr(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Gleich seid ihr dran</div>
        <h1 className="deck-title rise rise-2">
          Sechs Felder — <br />
          <span className="accent">eure Anforderung</span>
        </h1>
        <p className="deck-sub rise rise-3">
          Genau diese Felder erscheinen gleich auf dem Handy des
          Schriftführers. Ihr denkt gemeinsam, einer tippt.
        </p>
      </header>

      <div
        className="deck-cols2"
        style={{ gridTemplateColumns: "repeat(3, 1fr)", gridTemplateRows: "1fr 1fr", gap: 16 }}
      >
        {FELDER.map((f, i) => (
          <div key={f.label} className={`col-card rise rise-${(i % 3) + 4}`} style={{ padding: "20px 22px" }}>
            <div className="col-eyebrow">0{i + 1}</div>
            <h4 style={{ fontSize: "clamp(1rem, 1.6vw, 1.35rem)" }}>{f.label}</h4>
            <p style={{ fontSize: "clamp(0.85rem, 1.2vw, 1rem)" }}>{f.tipp}</p>
          </div>
        ))}
      </div>

      <footer className="deck-foot">
        <span>20 Minuten · die KI bewertet danach jede Anforderung — und baut daraus über Mittag euren Prototyp.</span>
      </footer>
    </div>
  );
}
